import VuexPersistence from 'vuex-persist';
import {
  STORAGE_VUEX_ACCOUNT_KEY,
  STORAGE_VUEX_ACCOUNT_VERSION,
} from '@motionelements/core/src/app.constants.js';

export default new VuexPersistence({
  key: STORAGE_VUEX_ACCOUNT_KEY,
  storage: window.sessionStorage,
  reducer: ({ user }) => ({
    hash: `${user.jwt.id}|${user.language}|${user.currencyCode}|${STORAGE_VUEX_ACCOUNT_VERSION}`,
    user: user,
  }),
  // eslint-disable-next-line
  filter: (mutation) => {
    // console.log(mutation);
    return [
      'user/setJwtId',
      'user/setJwtMember',
      'user/setMember',
      'user/setMemberCredits',
      'user/setLanguage',
    ].includes(mutation.type);
  },
});
